// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-page[data-v-89e3909c]{position:fixed;top:0;left:0;height:100%}", ""]);
// Exports
module.exports = exports;
